import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import FavouriteButton from "../FavouriteButton/FavouriteButton";
import useToast from "../../hooks/useToast";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import GuidelineChip from "../Guideline/GuidelineChip";
import ShareButton from "../ShareButton/ShareButton";
import { useState } from "react";
import useAppModernisation from "../../hooks/useAppModernisation";
import MoreButton from "./MoreButton";
import FontSizeAdjustorButton from "../FontSizeAdjustor/FontSizeAdjustorButton";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";
import { useLocation } from "react-router-dom";
import { useIsPregnancyBreastfeedingPage } from "../../utils/pregnancyPageUtils";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

const TopBarWeb = ({
  topicTitle,
  topicUrl,
  guideline,
  topicDetails,
  bannerText,
  expandExpertGroupsSideBar,
  expandUpdatesSideBar,
  setShowTopicActionBar,
  msPath,
}) => {
  const findInPage = useFindInPage();
  const fontSizeAdjustor = useFontSizeAdjustor();
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const iconFindInPage = classNames("tg-icons-FindInPage", "iconSize");
  const standardButtonStyle = classNames("size-14", style.button);
  const pageTocStyle = classNames("size-14", style.button);
  const toast = useToast();
  const { isMobileView } = useAppModernisation();
  const { pathname, search } = useLocation();
  const tocItems = useTableOfContents();

  const triggerToast = (added) => {
    toast.triggerToast({
      type: "info",
      primaryMessage: added ? "Added to favourites" : "Removed from favourites",
      rightText: isMobileView
        ? '<a href="/app/favourites">View</a>'
        : '<a href="/app/accountLanding">View</a>',
      autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
    });
  };

  const openFindInPage = (e) => {
    e.stopPropagation();
    fontSizeAdjustor.closeModal();
    setShareModalOpen(false);
    findInPage.openModal();
  };

  const openShareModal = (e) => {
    e.stopPropagation();
    findInPage.closeModal();
    fontSizeAdjustor.closeModal();
    setShareModalOpen(true);
  };

  const openFontSizeAdjustor = (e) => {
    e.stopPropagation();
    findInPage.closeModal();
    setShareModalOpen(false);
    fontSizeAdjustor.openModal();
  };

  const isPbsPage = useIsPregnancyBreastfeedingPage(search, pathname);

  return (
    <div className={style.topBarWeb}>
      <div className={style.header}>
        <div className={style.headline}>
          <h1>{bannerText}</h1>
        </div>
        <div className={style.chipContainer}>
          <GuidelineChip
            iconClassSuffix={topicDetails?.squareIconClass}
            linkText={topicDetails?.text}
            onClickProps={topicDetails?.onClickProps}
            showArrowIcon={false}
          />
        </div>
      </div>
      <div className={style.iconGroup}>
        {isMobileView ? (
          <>
            <FavouriteButton
              sectionTitle={topicTitle}
              sectionUrl={tocItems?.tableOfContents?.msPath}
              type="topic"
              topicSection={guideline}
              triggerToast={triggerToast}
              styling={pageTocStyle}
            />
            {!isPbsPage && (
              <MoreButton
                expandExpertGroupsSideBar={expandExpertGroupsSideBar}
                expandUpdatesSideBar={expandUpdatesSideBar}
                setShowTopicActionBar={setShowTopicActionBar}
                msPath={msPath}
              ></MoreButton>
            )}
          </>
        ) : (
          <>
            <button
              type="button"
              className={pageTocStyle}
              aria-label="Find in page"
              onClick={openFindInPage}
            >
              <i className={iconFindInPage}></i>
            </button>
            <FontSizeAdjustorButton onClick={openFontSizeAdjustor} styling={standardButtonStyle} />
            <ShareButton
              open={shareModalOpen}
              setOpen={setShareModalOpen}
              onClick={openShareModal}
              styling={standardButtonStyle}
            />
            <FavouriteButton
              sectionTitle={topicTitle}
              sectionUrl={tocItems?.tableOfContents?.msPath}
              type="topic"
              topicSection={guideline}
              triggerToast={triggerToast}
              styling={standardButtonStyle}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TopBarWeb;
